import {querySelectorAll} from "app/lib/helperjs";

const SPINNER_CLASS = '.sk-circle:not(.no-binding)';

export const Spinner = () => {
    const spinners = querySelectorAll(SPINNER_CLASS);
    let inside = [];

    for (let i = 1; i <= 12; i++) {
        inside.push(`<div class="sk-circle${i} sk-child"></div>`);
    }

    spinners.forEach((spinner) => {
        spinner.innerHTML = String(inside.join("")).trim();
    })
};
